import React, { useState } from 'react';
import { areModelsLoaded, unloadModels } from '../services/ModelService';

const DiagnosticTool = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [diagnosticResults, setDiagnosticResults] = useState({});

  const runDiagnostics = () => {
    // Check browser features
    const hasSpeechRecognition = 'SpeechRecognition' in window || 
                                'webkitSpeechRecognition' in window;
    
    // Check WebRTC/camera support
    const hasMediaDevices = !!(navigator.mediaDevices && 
                              navigator.mediaDevices.getUserMedia);
    
    // Check if models are loaded
    const modelsLoaded = areModelsLoaded();
    
    // Check for localStorage support
    let localStorageWorks = false;
    try {
      localStorage.setItem('test', 'test');
      localStorage.removeItem('test');
      localStorageWorks = true;
    } catch (e) {
      localStorageWorks = false;
    }

    // Check browser
    const browser = detectBrowser();

    // Results
    const results = {
      browser,
      speechRecognition: hasSpeechRecognition,
      camera: hasMediaDevices,
      modelsLoaded,
      localStorage: localStorageWorks,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString()
    };

    setDiagnosticResults(results);
  };

  const detectBrowser = () => {
    const userAgent = navigator.userAgent;
    let browserName;
    
    if (userAgent.match(/chrome|chromium|crios/i)) {
      browserName = "Chrome";
    } else if (userAgent.match(/firefox|fxios/i)) {
      browserName = "Firefox";
    } else if (userAgent.match(/safari/i)) {
      browserName = "Safari";
    } else if (userAgent.match(/opr\//i)) {
      browserName = "Opera";
    } else if (userAgent.match(/edg/i)) {
      browserName = "Edge";
    } else {
      browserName = "Unknown";
    }
    
    return browserName;
  };

  const resetModels = () => {
    const success = unloadModels();
    alert(success ? 
      'Models have been reset. Please refresh the page.' : 
      'Failed to reset models. Try refreshing the page.');
  };

  const clearStorage = () => {
    try {
      localStorage.removeItem('faceDescriptor');
      alert('Face data cleared. Please refresh the page.');
    } catch (e) {
      alert('Error clearing storage: ' + e.message);
    }
  };

  const copyDiagnostics = () => {
    const text = JSON.stringify(diagnosticResults, null, 2);
    navigator.clipboard.writeText(text)
      .then(() => alert('Diagnostic information copied to clipboard'))
      .catch(err => {
        console.error('Failed to copy text: ', err);
        alert('Failed to copy. Please select and copy the text manually.');
      });
  };

  return (
    <div className="diagnostic-tool">
      <button 
        className="diagnostic-button"
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? 'Hide Diagnostics' : 'Troubleshooting Tools'}
      </button>
      
      {isOpen && (
        <div className="diagnostic-panel">
          <h3>Troubleshooting Tools</h3>
          
          <div className="diagnostic-actions">
            <button onClick={runDiagnostics}>Run Diagnostics</button>
            <button onClick={resetModels}>Reset Face Models</button>
            <button onClick={clearStorage}>Clear Saved Face</button>
          </div>
          
          {Object.keys(diagnosticResults).length > 0 && (
            <div className="diagnostic-results">
              <h4>Diagnostic Results <button onClick={copyDiagnostics} className="copy-button">Copy</button></h4>
              <pre>{JSON.stringify(diagnosticResults, null, 2)}</pre>
              
              <div className="recommendations">
                <h4>Recommendations:</h4>
                <ul>
                  {!diagnosticResults.speechRecognition && (
                    <li className="error">Speech recognition not supported. Please use Chrome browser.</li>
                  )}
                  {!diagnosticResults.camera && (
                    <li className="error">Camera access not supported or blocked. Please enable camera permissions.</li>
                  )}
                  {!diagnosticResults.modelsLoaded && (
                    <li className="error">Face models failed to load. Try refreshing the page or check your internet connection.</li>
                  )}
                  {!diagnosticResults.localStorage && (
                    <li className="error">Local storage not available. Face registration data won't persist between sessions.</li>
                  )}
                  {diagnosticResults.browser !== 'Chrome' && (
                    <li className="warning">Using {diagnosticResults.browser}. For best experience, we recommend using Chrome.</li>
                  )}
                </ul>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default DiagnosticTool; 